import React, { useEffect } from 'react';
import { IoMdArrowRoundBack } from 'react-icons/io';
import RenderAlerts from 'components/RenderAlerts';
import { alertColorScale } from 'utils/alertUtils';
import AlertIcons from 'components/AlertIcons';
import { IconContext } from 'react-icons';
import { Alert, Icon } from '@mui/material';

export default function InfoPanel({ selectedAlert, setSelectedAlert, selectedZone }) {
  useEffect(() => {
    if (selectedZone?.alerts.length === 1) {
      setSelectedAlert(selectedZone.alerts[0]);
    }
  }, [selectedZone, setSelectedAlert]);

  return (
    <div className="d-flex w-100 pt-2">
      {selectedAlert ? (
        <div className="overflow-hidden p-1">
          <div className="d-flex flex-row align-items-center p-1 border-bottom border-1 border-light">
            <button onClick={() => setSelectedAlert(null)}>
              <IoMdArrowRoundBack size={24} className="mt-1 border-end border-1" />
            </button>
            <div
              className="d-flex p-1 ms-1 rounded-2 align-items-center justify-content-center"
              style={{
                backgroundColor: alertColorScale(selectedAlert.severity),
              }}
            >
              <p className="m-auto me-2 h4 fw-bold ">{selectedAlert.type}</p>
              <IconContext.Provider value={{ size: 30 }}>
                <AlertIcons type={selectedAlert.type} />
              </IconContext.Provider>
            </div>
          </div>
          <div>
            <h4 className="border-bottom border-1 border-light py-2">
              Headline: {selectedAlert.headline}
            </h4>
            <p className="border-bottom border-1 border-light py-2">
              Description: {selectedAlert.description}
            </p>
            <div className="d-flex flex-row pt-2 justify-content-between">
              <div className="me-1">
                <p>Start Time: {selectedAlert.startTime}</p>
                <p className="mt-1">End Time: {selectedAlert.endTime}</p>
              </div>
              <div className="border-end border-1 border-light me-1" />
              <div>
                <p>Sender: {selectedAlert.sender}</p>
                {selectedZone && <p className="mt-1">Zone: {selectedZone.zoneCode}</p>}
              </div>
            </div>
          </div>
        </div>
      ) : selectedZone?.alerts.length > 0 ? (
        <div className="w-100 overflow-hidden">
          <p className="h3 fw-bold">Zone {selectedZone.zoneCode}</p>
          <RenderAlerts arrayOfData={selectedZone.alerts} setSelectedAlert={setSelectedAlert} />
        </div>
      ) : (
        <p className="fw-bold h2">No zone selected</p>
      )}
    </div>
  );
}
